var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.show,
          expression: "show",
        },
      ],
      staticClass: "q-wrap h5-wrap vh-q-sdk",
      class: { isReplayH5: _vm.isReplay },
    },
    [
      _vm.enable_banner != 0
        ? _c("div", { staticClass: "vhall-question-title" }, [
            _c("img", { attrs: { src: _vm.headerImg, alt: "" } }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.config.showMyReward
        ? _c("div", { staticStyle: { "text-align": "right" } }, [
            _c(
              "div",
              _vm._g(
                {
                  staticClass: "reward-button",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.handleMyReward.apply(null, arguments)
                    },
                  },
                },
                _vm.$listeners
              ),
              [
                _c("i", { staticClass: "reward-button__icon" }),
                _vm._v(" "),
                _c("span", { staticClass: "reward-button__txt" }, [
                  _vm._v(_vm._s(_vm.$t("form.form_1091")) + " "),
                ]),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.q.title
        ? _c("div", {
            staticClass: "q-title",
            domProps: { textContent: _vm._s(_vm.q.title) },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.q.description
        ? _c(
            "div",
            {
              class: ["q-des", _vm.overflowStatus == 1 ? "introEllipsis" : ""],
              attrs: { id: "intro" },
            },
            [
              _vm._v("\n    " + _vm._s(_vm.q.description) + "\n    "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.overflowStatus == 1,
                      expression: "overflowStatus == 1",
                    },
                  ],
                  staticClass: "textTail",
                  on: {
                    click: function ($event) {
                      return _vm.handleUnfold(2)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "isEllipsis" }, [_vm._v("... ")]),
                  _vm._v(_vm._s(_vm.$t("form.form_1011")) + "\n    "),
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.overflowStatus == 2,
                      expression: "overflowStatus == 2",
                    },
                  ],
                  staticClass: "textTail",
                  on: {
                    click: function ($event) {
                      return _vm.handleUnfold(1)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "isEllipsis" }),
                  _vm._v(_vm._s(_vm.$t("form.form_1012")) + "\n    "),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "q-split" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "q-list" },
        _vm._l(_vm.q.detail, function (item, index) {
          return _c(
            "com-question",
            {
              key: index,
              ref: "com" + index,
              refInFor: true,
              attrs: {
                detail: _vm.q.detail,
                isReplay: _vm.isReplay,
                value: item,
              },
              on: {
                "update:value": function ($event) {
                  item = $event
                },
              },
            },
            [_vm._v(">")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.privacyDate.privacyConten
        ? _c("qPrivacy", {
            ref: "qPrivacy",
            attrs: { privacyDate: _vm.privacyDate, isPreview: true },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.config.isPreview & !_vm.isReplay
        ? _c(
            "div",
            { class: ["q-btns", _vm.showVhPrivacy ? "q-btns__privacy" : ""] },
            [
              _c(
                "span",
                {
                  attrs: { id: "ques_sdk_sub_btn" },
                  on: { click: _vm.doSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("form.form_1045")))]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }